export default {
  lastErrors: [],
  isLogin: false,
  token: null,
  login(contex, creds) {
    contex.$root.loading++;
    contex.$http.post('user/token', JSON.stringify(creds)).then((response) => {
      if (response.body.hasOwnProperty('token')) {
        localStorage.setItem('token', response.body.token);
        this.isLogin = true;
        this.token = response.body.token;
        this.saveOldAccounts(creds);

      }
      contex.$root.loading--;
      this.refreshUser();
      contex.$router.push({
        name: 'home',
      });
      contex.$bus.$emit('A_LOGIN_USER', {});
    }).catch((response) => {
      localStorage.removeItem('token');
      if (response.status === 401) {
        this.lastErrors = response.body.message;
      }
      if (response.status === 404) {
        contex.$notify({
          title: 'Giriş Hatası',
          message: 'Kullanıcı hatası veya şifre hatalı',
          type: 'error'
        });
      }
      contex.$root.loading--;
      this.refreshUser();
    })

  },
  logout: function () {
    localStorage.removeItem('token');
    this.isLogin = false;
    this.token = null;
  },
  refreshUser() {
    if (localStorage.getItem('token')) {
      this.token = localStorage.getItem('token');
      this.isLogin = true;
    }
  },
  saveOldAccounts(creds){
    let oAS = JSON.parse(localStorage.getItem('oas'));
    if(!oAS){
      oAS = {};
    }
    oAS[creds.username] = {
      username:creds.username
    };
    localStorage.setItem('oas',JSON.stringify(oAS));
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js